import isServer from './isServer';
import getCookies from './getCookies';
import isProd from './isProd';
import { getStoreDetailsForHostname } from './storeDetails';

const getStoreDetails = () => {
  if (isServer()) {
    return null;
  }

  // Only allow cookie override in non-production environments
  const rawHostName =
    (!isProd() && getCookies().get('storeHostName')) ||
    window.location.hostname;

  return getStoreDetailsForHostname(rawHostName);
};

export default getStoreDetails;
